export default __webpack_public_path__ + "static/dots2-096820508a50bb1e690bd80ac97b9267.svg";